module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular.c1678b46.ttf";